<template>
    <div class="input-group" id="subscribe-now-form">
        <input
            type="email"
            name="email"
            class="form-control subscribe-now-input"
            id="subscribe-now-input"
            placeholder="Enter your email"
            aria-label="Enter your email"
            v-model="email"
        />
        <div class="input-group-append">
            <button
                class="btn btn-sm btn-primary subscribe-now-submit"
                id="subscribe-now-submit"
                type="button"
                :disabled="submitting"
                @click.prevent="subscribeToNewsletter"
            >
                &#8594;
            </button>
        </div>
    </div>
</template>

<script>
import { HTTP } from "../api";

export default {
    data() {
        return {
            submitting: false,
            email: "",
        };
    },
    methods: {
        async subscribeToNewsletter() {
            this.submitting = true;
            try {
                await HTTP.post("subscribe", { email: this.email });
                this.email = "";
                this.$notification.success({
                    message: "Email added to subscription list.",
                });
            } catch (error) {
                if (
                    error?.response?.status === 422 &&
                    error?.response?.data?.errors?.email
                ) {
                    this.$notification.error({
                        message: error?.response?.data?.errors?.email[0],
                    });
                } else {
                    // Server Error
                }
            }
            this.submitting = false;
        },
    },
};
</script>
